import styles from 'src/js/common/components/formatters/TextFormatter.less';
import baseTextFormatterParams from 'src/js/lib/raw_rendering/base_text_formatter_params';

/**
 * Returns raw Html version of TextFormatter component.
 * @param params
 * @param services
 * @returns {String}
 */
export default function textFormatter(params, services = {}) {
  const {formattedValue, hasValue, label, valueStyle} = baseTextFormatterParams(
    params,
    services
  );

  return hasValue
    ? `<div class="${styles.dlTextFormatter}" title="${label}">
            <span
                class="${styles.dlTextFormatterValue}"
                style="${valueStyle}"
            >
                ${formattedValue}
            </span>
        </div>`
    : '';
}
